import { render, staticRenderFns } from "./RememberThisModal.vue?vue&type=template&id=00d5056a&"
import script from "./RememberThisModal.vue?vue&type=script&lang=js&"
export * from "./RememberThisModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports